import PermissionDeniedImage from '@assets/images/PermissionDenied.png'
import AppPaths from '@globals/paths'
import { KUDOS } from '@globals/paths/useDocumentTitle'
import { T } from '@transifex/react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import ErrorPageLayout from '../../routes/errors/ErrorPageLayout'

const PermissionDeniedUI: React.FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    document.title = `${KUDOS} - Access denied`
  }, [])

  const handleClick = () => {
    navigate(AppPaths.tenant.home())
  }

  return (
    <ErrorPageLayout
      title={<T _str="Access denied" />}
      onClick={handleClick}
      buttonText={<T _str="Back to home" />}
      errorImage={PermissionDeniedImage}
      description={
        <T _str="You don’t have permission to view this page. If you think you should have access, reach out to your admin." />
      }
    />
  )
}

export default PermissionDeniedUI
